import React, {useEffect, useRef, useState} from "react";
import {SoButton} from "../../UI/Button/so-button";
import "./create-sign-document.css";
import axios from "../../../api/axiosApi";
import { getStoredToken } from "../../../utils";
import {DocusealBuilder} from "@docuseal/react";
import {captureError} from "../../../utils";

export const CreateSignDocument = ({file, close}) => {
    const [isUploading, setIsUploading] = useState(false);
    const [token, setToken] = useState(null);
    const [slug, setSlug] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setTimeout(async () => {
            try {
                let response = await axios.get('documents/enable?url=' + file.url + '&name=' + file.originalname + '&documentId=' + file._id, {
                    headers: {
                        'micro-service': 'appointment',
                        "Content-Type": "multipart/form-data",
                        "Authorization": "Bearer " + getStoredToken()
                    },
                });
                setToken(response.data.token);
            } catch (e) {
                console.error(e);
                captureError(e, {
                    errorType: 'docuseal_enable_error',
                    context: {
                        fileId: file?._id,
                        fileName: file?.originalname,
                        fileUrl: file?.url,
                    },
                });
                setError('Unable to load the document editor. Please try again.');
                setLoading(false);
            }
        });
    }, []);

    // Monitor Docuseal builder script loading
    useEffect(() => {
        if (!token) return;
        const scriptId = 'docuseal-builder-script';
        const checkScript = () => {
            const script = document.getElementById(scriptId);
            if (script) {
                script.addEventListener('error', (e) => {
                    const err = new Error('Docuseal builder script failed to load');
                    err.src = script.src;
                    err.fileId = file?._id;
                    captureError(err, {
                        errorType: 'docuseal_script_load_error',
                        context: {
                            src: script.src,
                            fileId: file?._id,
                            fileName: file?.originalname,
                        },
                    });
                    setError('Unable to load the document editor. Please refresh the page to try again.');
                    setLoading(false);
                });
                return;
            }
            setTimeout(checkScript, 100);
        };
        checkScript();

        const timeout = setTimeout(() => {
            if (loading) {
                const err = new Error('Docuseal builder load timeout after 30s');
                err.fileId = file?._id;
                captureError(err, {
                    errorType: 'docuseal_load_timeout',
                    context: {
                        fileId: file?._id,
                        fileName: file?.originalname,
                        scriptExists: !!document.getElementById(scriptId),
                    },
                });
                setError('The document editor is taking too long to load. Please check your connection and try again.');
                setLoading(false);
            }
        }, 30000);

        return () => clearTimeout(timeout);
    }, [token]);

    const upload = async () => {
        if (!slug) {
            close(true);
            return;
        }
        setIsUploading(true);
        await axios.get(`documents/enable-esignature?slug=${slug}&url=${file.url}`, {
            headers: {
                'micro-service': 'appointment',
                "Content-Type": "multipart/form-data",
                "Authorization": "Bearer " + getStoredToken()
            },
        });
        close(true);
        setIsUploading(false);
    };

    return (<>
         <div className={'header'}>
                <h4>Add fields to {file.originalname.slice(0, 20)}</h4>
                <div className={'header-action'}>
                    <div>
                        <button
                            className="sos-custom-btn-new-message sos-secondary-btn-css so-btn"
                            onClick={() => close(false)}
                        >
                            Cancel
                        </button>
                    </div>
                    <div>
                        <SoButton isLoading={isUploading}
                                  onClick={() => upload()}
                                  text={'Save'}></SoButton>
                    </div>
                </div>
            </div>
    <div className={'document-container'}>
                <div className={'panel-container'}>
                    <div>
                        <p><b>Instructions:</b> Drag and drop fields from the right column onto the document.</p>
                    </div>
                    {error && <div className={'error'} style={{color: 'red', padding: '10px'}}>
                        {error}
                    </div>}
                    <div className={'viewer-container'}>
                        {token && <DocusealBuilder
                            host={'docuseal.sosoftpay.com'}
                            fieldTypes={['text', 'signature', 'initials', 'date', 'number', 'checkbox','radio','select']}
                            token={token}
                            // externalId={file._id}
                            onLoad={() => {
                                setLoading(false);
                            }}
                            onSave={(data) => {
                                setSlug(data.slug);
                            }}
                            customCss={`
                    #title_container{display: none;}
                    .dropdown {color: #000;}
                    .sticky {color: #000;}
                    div > div > div.flex.sticky.top-0.z-50.space-x-2.items-center.bg-yellow-100.p-2.border-y.border-yellow-200 {display: none;}
                    #pages_container > div > div.flex.space-x-2.pb-2.mb-2.border-b.border-base-300.border-dashed {display: none;}
                    #pages_container > div > div.pb-4.space-y-2 {display: none;}
                    #main_container{min-height: 100vh;color: #000;}
                    #add_document_button{display: none;}
                    `}/>}
                    </div>
                </div>
            </div>
    </>
    );
};
